/**
 * Garde globale du back-office : un compte connecté SANS rôle back-office
 * (élève ou parent de l'app mobile…) voit la page « Accès refusé »
 * existante au lieu des écrans (échec fermé, audit console S-5).
 * Le backend reste la vraie barrière ; ceci évite d'afficher la console.
 */
import React from 'react';
import { useRBAC } from '../../contexts/RBACContext';
import UnauthorizedPage from '../../pages/UnauthorizedPage';

const RoleGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { claims, loading } = useRBAC();
  if (!loading && !claims) {
    return <UnauthorizedPage />;
  }
  return <>{children}</>;
};

export default RoleGate;
